module.exports = __webpack_public_path__ + "static/media/pzbad_logo.812e2395.png";